import styled from 'styled-components'
import { device } from '../Breakpoints'

export const Container = styled.footer`
  background: #fff;
  padding-top: 40px;
  background-position: center 35px;
  background-repeat: no-repeat;
  @media ${device.desktopL} {
    background-size: cover;
  }
  @media ${device.laptop} {
    padding: 2em 2em 0.5em;
    margin-top: 0px;
    background-size: cover;
    background-position: -650px 0;
    h4 {
      margin: 0;
      text-align: center;
    }
  }
  .inner {
    min-height: 490px;
    max-width: 960px;
    padding: 0 170px;
    margin: auto;
    @media ${device.laptop} {
      padding: 0px;
      min-height: 0;
    }

    .certificacoes,
    .footerNav {
      display: flex;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        float: left !important;
      }
      @media ${device.laptop} {
        flex-direction: column;
        justify-items: center;
      }
      .social {
        margin-right: 0;
        a {
          padding: 0.5em 0.5em 1.5em;
          :hover {
            color: #ffffff;
          }
          svg {
            width: 2em;
            height: 2em;
          }
        }
      }
      div:not(.gatsby-image-wrapper) {
        margin-top: 30px;
        margin-right: 65px;
        @media ${device.laptop} {
          margin-right: 0px;
        }
        :nth-child(3) {
          margin-right: 30px;
        }
        ul {
          margin: 0;
          padding: 0;
          li {
            margin: 0 0 5px;
            list-style: none;
            a {
              font-size: 0.79em;
              color: #148581;
              text-decoration: none;
              :hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
    .certificacoes {
      p {
        width: 235px;
        margin: auto 0px;
        @media ${device.laptop} {
          margin: 20px auto;
        }
      }
      div {
        margin: auto;
      }
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        clear: both !important;
        display: block !important;
      }
    }
    .footerNav {
      @media ${device.laptop} {
        div {
          display: none;
        }
        div.social {
          display: block;
        }
      }
      div:first-child {
        min-width: 160px;
      }
    }
    h4 {
      font-weight: normal;
    }
    p {
      color: #148581;
      font-size: 0.8em;
      margin-right: 11px;
      margin-top: 15px;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        float: left !important;
        width: 25% !important;
      }
      @media ${device.laptop} {
        max-width: 100%;
        margin-right: 0px;
        text-align: center;
      }
    }
    img {
      margin-right: 80px;

      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /**
    Target IE11
    */
        margin-right: 0 !important;
        padding-right: 80px !important;
        float: left;
      }
      :last-child {
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /**
    Target IE11
    */
          padding-right: 0 !important;
        }
      }
      @media ${device.laptop} {
        margin: auto auto 20px;
      }
    }
  }
`
export const Info = styled.div`
  background: #539e9f;
  display: block;
  padding: 1.5em 1.5em 100px 1.5em;
  color: #ffffff;
  text-align: center;
  font-size: 0.7em;
  line-height: 1.6em;
  font-family: 'Santral Light', Arial, Helvetica, sans-serif;
  p {
    margin: 0;
    @media ${device.laptop} {
      margin: 2em 0;
    }
  }
`
